import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PracticeDetail } from "@/core/types";

import { getPractice } from "../queryFunctions/getPractice";
import { practiceKeys } from "../keyFactory";

type UsePracticeProps<TData = PracticeDetail> = {
  enabled?: boolean;
  practiceId: string;
  select?: (data: PracticeDetail) => TData;
};

type PracticeQueryOptions = UseQueryOptions<
  PracticeDetail,
  unknown,
  PracticeDetail,
  ReturnType<typeof practiceKeys.details>
>;

function optionFactory(practiceId: string) {
  return {
    queryFn: () => getPractice(practiceId),
    queryKey: practiceKeys.details(practiceId),
  } satisfies PracticeQueryOptions;
}

export function usePractice<TData = PracticeDetail>({
  enabled = true,
  practiceId,
  select,
}: UsePracticeProps<TData>) {
  return useQuery({ ...optionFactory(practiceId), enabled, select });
}
